<script>
import { useCredentialsStore } from '@/stores/credentials.js';
import NavBar from '@/NavBar.vue';
import { useMetersStore } from '@/stores/meters.ts';

export default {
  name: 'App',
  components: { NavBar },
  data() {
    return {
      credStore: useCredentialsStore(),
    };
  },
  created() {
    useMetersStore().$subscribe((mutation, state) => {
      this.setThemeIfMeterSet();
    });

    this.setThemeIfMeterSet();
  },
  methods: {
    setThemeIfMeterSet() {
      const meter = useMetersStore().getMeterDetails;
      if (meter) {
        const companyId =
          useMetersStore().getMeterDetails.plant.logged_in_for_company;
        document.documentElement.classList.add('theme-' + companyId);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full text-theme-primary">
    <div class="flex flex-col grow">
      <RouterView/>
      <!-- compensate for fixed footer-->
      <div class="h-20"/>
    </div>

    <footer class="fixed bottom-0 w-full self-center">
      <nav-bar v-if="credStore.isSignedIn"/>
    </footer>
  </div>
</template>

<style scoped></style>
